import React from 'react';
import classes from "./Placeholder.module.scss";

function Placeholder({name, className}) {
    function getInitials(name) {
        if (name) {
            const words = name.split(' ');
            const firstLetter = words.length > 0 ? words[0].charAt(0) : '';
            let secondLetter = '';
            if (words.length > 1) {
                secondLetter = words[1].charAt(0);
            }
            return firstLetter + secondLetter;
        }
    }


    return (<div className={`${classes.placeholder} ${className}`}>
            <h1>{getInitials(name)}</h1>
        </div>);
}

export default Placeholder;